import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { instantToWallClock, offsetToMinutes } from 'tools/date/site-time';

dayjs.extend(utc);

export { offsetToMinutes, instantToWallClock };

export function formatSince(date: string, time: string): string {
    return `${date}T${time}Z`;
}

export function windowEndLabel(date: string, time: string): string {
    return dayjs(`${date}T${time}`).add(6, 'hour').format('HH:00');
}

// "Ahora" en el wall-clock del sitio (offset del lock) para que el backend, que reinterpreta el
// "Z" en la TZ del lock, reciba la hora local correcta. Sin offset → wall-clock del device (fallback).
export function nowSince(offset?: string): { date: string; time: string } {
    if (!offset) {
        const now = dayjs();
        return { date: now.format('YYYY-MM-DD'), time: now.format('HH:00:00') };
    }
    return instantToWallClock(dayjs(), offset);
}
